import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";

const modeloDatos = {
    seguroID: 0,
    empresaID: 0,
    codigoSeguro: 0,
    rnc: "",
    descripcion: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const Seguros = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    const onBusqueda = async (e) => {
        var l = Listado1;

        var searchData = l.filter((item) => {
            if (
                (item.descripcion + item.seguroID + item.codigoSeguro+ item.rnc)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())

            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + JSON.parse(user).correo +"/1");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data);
                setPendiente(false)
            }
        }

        }

    useEffect(() => {
        obtenerDatos();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.seguroID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "CMantenimiento/GuardarSeguros", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "CMantenimiento/EditarSeguros", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.seguroID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        }, {
            name: 'Codigo Seguro ',
            selector: row => row.codigoSeguro,
            sortable: true,
        },
            {
            name: 'RNC ',
            selector: row => row.rnc,
            sortable: true,
        },


      
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Seguros
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md="2">
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Seguro</Button>
                </Col> <Col>
                    <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de Seguro " ></Input>
                </Col>
            </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="">
                <ModalHeader className="modal-header1" >
                    Mantenimiento de Seguros
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Nombre del Seguro </Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />

                            </FormGroup>
                        </Col> <Col sm={6}>
                            <FormGroup>
                                <Label>Codigo Seguro</Label>
                                <Input bsSize="sm" name="codigoSeguro" maxlength="6" onChange={handleChange} value={tabla.codigoSeguro} />

                            </FormGroup>
                        </Col>
                      

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Seguros;